import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiGetGSCCredentialsMethod,
    type OpenApiGetGSCCredentialsRequest,
    type OpenApiGetGSCCredentialsResponseSuccess,
    OpenApiGetGSCCredentialsUrl,
    OpenApiGSCHealthMethod,
    type OpenApiGSCHealthRequest,
    type OpenApiGSCHealthResponseSuccess,
    OpenApiGSCHealthUrl,
    OpenApiGSCIntegrationMethod,
    type OpenApiGSCIntegrationRequest,
    type OpenApiGSCIntegrationResponseSuccess,
    OpenApiGSCIntegrationUrl,
} from '#shared/api/schema';

const GSCHealthTag = 'GSCHealth' as const;

const api = createApi({
    name: 'entities/integration/api/googleSearchConsoleApi',
    baseQuery: createBaseQuery(apiV1Request),
    tagTypes: [GSCHealthTag],
    endpoints: (builder) => {
        return {
            getHealth: builder.query<OpenApiGSCHealthResponseSuccess, OpenApiGSCHealthRequest>({
                query: () => {
                    return {
                        url: OpenApiGSCHealthUrl,
                        method: OpenApiGSCHealthMethod,
                    };
                },
                providesTags: [GSCHealthTag],
            }),
            getCredentials: builder.query<OpenApiGetGSCCredentialsResponseSuccess, OpenApiGetGSCCredentialsRequest>({
                query: () => {
                    return {
                        url: OpenApiGetGSCCredentialsUrl,
                        method: OpenApiGetGSCCredentialsMethod,
                    };
                },
                keepUnusedDataFor: 0,
            }),
            connect: builder.mutation<OpenApiGSCIntegrationResponseSuccess, OpenApiGSCIntegrationRequest>({
                query: (payload) => {
                    return {
                        url: OpenApiGSCIntegrationUrl,
                        method: OpenApiGSCIntegrationMethod,
                        body: payload,
                    };
                },
            }),
        };
    },
});

export const useGSCIntegrationHealth = api.useGetHealthQuery;
export const invalidateGscIntegrationHealth = () => api.util.invalidateTags([GSCHealthTag]);
export const integrationGscCredentialsGet = api.endpoints.getCredentials.query;
export const connectIntegrationGoogleSearchConsole = api.endpoints.connect.mutate;
